// extracted by mini-css-extract-plugin
export default {"icon":"SwipeIndicator_icon__a0vA6","tiltRightToLeft":"SwipeIndicator_tiltRightToLeft__TNv7X"};